import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M13 3h-5v5","key":"svg-0"}],["path",{"d":"M8 3l7.536 7.536a5 5 0 0 1 1.464 3.534v6.93","key":"svg-1"}]]

/**
 * IconArrowBearLeft
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYXJyb3ctYmVhci1sZWZ0Igo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0xMyAzaC01djUiIC8+CiAgPHBhdGggZD0iTTggM2w3LjUzNiA3LjUzNmE1IDUgMCAwIDEgMS40NjQgMy41MzR2Ni45MyIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/arrow-bear-left
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconArrowBearLeft = createReactComponent('outline', 'arrow-bear-left', 'ArrowBearLeft', __iconNode);

export default IconArrowBearLeft;